import basicController from "servicestack/basic.controller.properties";
import Product from "emun.shopping/product.model";
import templateUrl from "emun.swatch/swatch-scan.htm";
import AutoQuery from "servicestack/auto-query/auto-query";
import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";
import $appConfig from "servicestack/config";
import SwatchScanController from "emun.swatch/swatch-scan.controller";
import "emun.swatch/swatch-scan.client.scss";

const SwatchScan = {
  controller: SwatchScanController,
  bindings: {
    countId: "@",
    count: "<",
  },
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};

export default SwatchScan;
